import { render, staticRenderFns } from "./ForgotPassSuccess.vue?vue&type=template&id=15ac22ba&scoped=true&"
import script from "./ForgotPassSuccess.vue?vue&type=script&lang=js&"
export * from "./ForgotPassSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac22ba",
  null
  
)

export default component.exports